export const defaultLabelParamName = 'label';
export const defaultValueParamName = 'value';
export const defaultGutter = [20, 20];
